import { Box, Grid, Modal, Typography } from "@material-ui/core";
import React from "react";
import ButtonLoader from "./ButtonLoader";

export default function CouponSelectModal({
  openModal,
  setOpenModal,
  handleUseCoupon,
  handleDontUseCoupon,
  handleCouponClose,
}) {
  return (
    <Modal open={openModal} onClose={handleCouponClose}>
      <Box className="modal-wrapper">
        <Box className="modal">
          <Box className="modal-body">
            <div>
              <Grid
                container
                justifyContent="center"
                style={{ marginTop: "1.5rem" }}
              >
                <Grid item md={10}>
                  <Typography
                    variant="h5"
                    color="primary"
                    style={{
                      fontWeight: "800",
                      marginBottom: "1.5rem",
                      fontFamily: "Noto Serif JP",
                    }}
                  >
                    利用可能なクーポンがあります。
                    <br />
                    利用しますか？
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="center"
                style={{ marginTop: "1.5rem" }}
              >
                <Grid item md className="modal-button-wrapper">
                  <button className="main-btn" onClick={handleDontUseCoupon}>
                    利用しない
                  </button>
                  <button className="secondary-btn" onClick={handleUseCoupon}>
                    利用する
                  </button>
                </Grid>
              </Grid>
            </div>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
